(function () {
  'use strict';

  if (window.__phdMiniCartCouponsInit) return;
  window.__phdMiniCartCouponsInit = true;

  var SUCCESS_AUTO_CLOSE_MS = 8400;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(0);
    amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '\u20B9' + amount;
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function dispatchCartUpdates(cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
  }

  function showSuccess(code, savedCents) {
    var wrap = document.querySelector('[data-mc-success]');
    if (!wrap) return;
    var savedEl = wrap.querySelector('[data-mc-success-saved]');
    var codeEl = wrap.querySelector('[data-mc-success-code]');
    if (savedEl) savedEl.textContent = formatMoney(savedCents || 0);
    if (codeEl) codeEl.textContent = code;
    wrap.hidden = false;
    wrap.setAttribute('aria-hidden', 'false');
    wrap.querySelectorAll('.mc-success__bit').forEach(function (b) {
      b.style.animation = 'none';
      void b.offsetWidth;
      b.style.animation = '';
    });
    clearTimeout(showSuccess._t);
    showSuccess._t = setTimeout(closeSuccess, SUCCESS_AUTO_CLOSE_MS);
  }

  function closeSuccess() {
    var wrap = document.querySelector('[data-mc-success]');
    if (!wrap) return;
    wrap.hidden = true;
    wrap.setAttribute('aria-hidden', 'true');
    clearTimeout(showSuccess._t);
  }

  function showError(msg) {
    var box = document.querySelector('[data-mc-manual-error]');
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
  }

  function hideError() {
    var box = document.querySelector('[data-mc-manual-error]');
    if (box) box.hidden = true;
  }

  function setLoading(btn, isLoading) {
    if (!btn) return;
    if (isLoading) {
      btn.classList.add('mc-coupons__apply--loading');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.classList.remove('mc-coupons__apply--loading');
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  }

  function findAppliedDiscount(cart, code) {
    var upper = String(code || '').toUpperCase();
    var result = null;
    if (cart && Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach(function (d) {
        if (d && d.title) {
          if (!upper || d.title.toUpperCase() === upper) {
            if (!result) result = d;
          }
        }
      });
    }
    return result;
  }

  function applyCoupon(code, applyBtn, inputEl) {
    if (!code) { showError('Please enter a coupon code'); return; }
    setLoading(applyBtn, true);
    var beforeTotal = 0;

    getCart()
      .then(function (before) {
        beforeTotal = before.total_price || 0;
        return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'follow' });
      })
      .then(function () { return getCart(); })
      .then(function (after) {
        var afterTotal = after.total_price || 0;
        var match = findAppliedDiscount(after, code);
        var saved = 0;
        if (match) saved = match.total_allocated_amount || Math.max(0, beforeTotal - afterTotal);
        else saved = Math.max(0, beforeTotal - afterTotal);

        setLoading(applyBtn, false);
        if (match || saved > 0) {
          if (inputEl) inputEl.value = '';
          hideError();
          showSuccess(String(code).toUpperCase(), saved);
          dispatchCartUpdates(after);
        } else {
          showError("Sorry, that code isn't valid for your cart.");
        }
      })
      .catch(function () {
        setLoading(applyBtn, false);
        showError('Something went wrong. Please try again.');
      });
  }

  function removeCoupon(btn) {
    if (!btn) return;
    btn.disabled = true;
    btn.dataset.prevText = btn.textContent;
    btn.textContent = 'Removing…';

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function () {
        return fetch('/discount/_clear_' + Date.now(), { credentials: 'same-origin', redirect: 'follow' })
          .catch(function () { return null; });
      })
      .then(function () { return getCart(); })
      .then(function (after) {
        dispatchCartUpdates(after);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = btn.dataset.prevText || 'Remove';
        showError('Could not remove coupon. Please try again.');
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-mc-manual-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('[data-mc-manual-input]');
    if (!input) return;
    applyCoupon((input.value || '').trim(), form.querySelector('.mc-coupons__apply'), input);
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches('[data-mc-manual-input]')) hideError();
  });

  /* Early capture-phase blocker: stops focus-trap (and any other
     outside-click detectors) from seeing clicks/taps inside the
     success popup. We handle our own close logic here and then
     stopImmediatePropagation so same-document listeners don't fire. */
  function capturePopupEvent(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var success = document.querySelector('[data-mc-success]');
    if (!success || success.hidden) return;
    var inPopup = t.closest('.mc-success');
    if (!inPopup) return;

    if (e.type === 'click' && t.closest('[data-mc-success-close]')) {
      e.preventDefault();
      closeSuccess();
    }
    e.stopImmediatePropagation();
  }
  document.addEventListener('click', capturePopupEvent, true);
  document.addEventListener('mousedown', capturePopupEvent, true);
  document.addEventListener('touchstart', capturePopupEvent, { capture: true, passive: false });

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-mc-remove]');
    if (removeBtn && !removeBtn.disabled) {
      e.preventDefault();
      removeCoupon(removeBtn);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var success = document.querySelector('[data-mc-success]');
      if (success && !success.hidden) closeSuccess();
    }
  });

  function watchDrawerClose() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var wasOpen = drawer.hasAttribute('open');
    new MutationObserver(function () {
      var isOpen = drawer.hasAttribute('open');
      if (wasOpen && !isOpen) {
        hideError();
        var input = document.querySelector('[data-mc-manual-input]');
        if (input) input.value = '';
      }
      wasOpen = isOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawerClose);
  } else {
    watchDrawerClose();
  }
})();
